import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import ProfileView from './profile.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useProfileRoutes = () => (
  <Route
    path={pages.profile.path}
    element={
      <ProtectedRoute module="profile" checkAnySubmodule>
        <ProfileView />
      </ProtectedRoute>
    }
  >
    <Route
      index
      element={
        <ProtectedRoute module="profile" checkAnySubmodule>
          <ProfileView />
        </ProtectedRoute>
      }
    />
    <Route
      path={pages.profile.path + '/:profileSubRouteId'}
      element={
        <ProtectedRoute module="profile" checkAnySubmodule>
          <ProfileView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useProfileRoutes;
